export default (string) => {
  if (typeof string === 'undefined') {
    return ''
  }

  return encodeURIComponent(string)
}



/** WEBPACK FOOTER **
 ** /Users/kacper/workspace/react-sharingbuttons/src/utils/encodeURI.js
 **/